import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';

class ItemVariantsFields extends React.Component {
  render() {
    const { member, isDisableForm, index, fields } = this.props;
    const isHide =
      fields.length === 1 &&
      (fields.get(index).name === undefined ||
        fields.get(index).name === null ||
        fields.get(index).name === '')
        ? 'hide'
        : 'show';
    const cssColumn = isHide === 'hide' ? 'col-md-6' : 'col-md-4';
    return (
      <div className="mk-grouped-input">
        {isHide !== 'hide' && (
          <div className={`form-group col-md-4`}>
            <Field
              name={`${member}.name`}
              component={SettingField}
              className="form-control"
              placeholder="Name"
              dis={isDisableForm}
            />
          </div>
        )}
        <div
          className={`form-group ${
            cssColumn === 'col-md-6' ? 'col-md-6' : 'col-md-4 no-padding'
          }`}
        >
          <Field
            name={`${member}.price`}
            component={SettingField}
            placeholder="Price"
            inputClassName="text-right"
            positiveNumberOnly
            dis={isDisableForm}
          />
        </div>
        <div className={`form-group ${cssColumn}`}>
          <Field
            name={`${member}.sku`}
            component="input"
            disabled={isDisableForm}
            className="form-control text-align-last-left"
            placeholder="SKU"
          />
        </div>
      </div>
    );
  }
}

ItemVariantsFields.propTypes = {
  member: PropTypes.object,
  index: PropTypes.integer,
};

export default ItemVariantsFields;
